import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import styles from './BuySharedTitle.scss';

function BuySharedTitleComponent({ buyPage }) {
    return (
        <h1 className={styles.header} data-tn="buy-page-header">
            <FormattedMessage
                id="BuySharedTitle.headerTitle"
                defaultMessage="{header} ({count} for sale)"
                values={{
                    header: get(buyPage, 'meta.header'),
                    count: buyPage.totalResults,
                }}
            />
        </h1>
    );
}

BuySharedTitleComponent.propTypes = {
    buyPage: PropTypes.object.isRequired,
};

export const BuySharedTitle = createFragmentContainer(BuySharedTitleComponent, {
    buyPage: graphql`
        fragment BuySharedTitle_buyPage on ItemSearchQueryConnection {
            totalResults
            meta {
                header
            }
        }
    `,
});
